import { InputLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Label = styled(InputLabel)(({ theme }) => ({
  color: theme.palette.onSurfaceSecondary.main,
  lineHeight: '22px',
  whiteSpace: 'normal',

  '&.Mui-disabled': {
    color: theme.palette.onTertiary.main,
  },
}));
